enum Route {
  Welcome = '/welcome',
  ChooseConfiguration = '/choose-configuration',
}

export default Route
